<template>
  <div>
    <Header :home="false" :logged="logged" :arealogada="true" />

    <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <p class="my-4">
        <template>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>

    <!-- Modal Detalhes do Pedido de Retirada -->
    <RetiradaDetalhe ref="modalRetiradaDetalhe" />

    <!-- Modal de Pagamento Retirada (CC e PIX realtime) -->
    <ModalPagamentoRealtime
      ref="modalPagamentoRetirada"
      modal-id="retirada-lista"
      :value="valorRetirada"
      :formas-pagamento="formasPagamentoRetirada"
      @pagamento-realizado="onPagamentoRealizado"
    />

    <!-- Tutorial guiado -->
    <TutorialGuiado
      ref="tutorial"
      nm-tutorial="pedido_retirada"
      @ativo="tutorialAtivo = $event"
      @concluido="pesquisar"
    />

    <div
      class="text-center"
      v-if="loading"
      style="
        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;
      "
    >
      <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>

    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu d-none d-xl-block">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex painel-content">
          <b-alert variant="warning" show>Pesquisas sem filtro irão retornar as 50 últimas solicitações</b-alert>
          <b-container fluid id="painelcontainerfluid">
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;">
                <b-link
                  class="btn-voltar"
                  href="/painel"
                  style="text-decoration:none;font: normal normal bold 16px/24px 'Kanit', sans-serif;color:#597EB5;"
                >
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>

            <arealogadapesquisa
              id="tabela-pedido-retirada"
              :resultado="itemFiltrado"
              :colunas="colunas"
              :colunasMobile="colunasMobile"
              :hasFilter="true"
              :page="'PedidoRetirada'"
              :title="'Pedidos de Retirada'"
              @filtrarBusca="filtrarBusca"
              @chamar-funcao="executarFuncao"
            />

          </b-container>
        </b-col>
      </b-row>
    </div>

    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none" />
  </div>
</template>

<script>
import Header from '@/components/Header';
import Menu from '@/template/Menu';
import API from '@/services/api';
import Swal from 'sweetalert2';
import arealogadapesquisa from '@/components/arealogada/pesquisa/index.vue';
import footersite from '@/components/footersite';
import footersitemobile from '@/components/footersite/index_mobile';
import ModalPagamentoRealtime from '@/components/modal/ModalPagamentoRealtime.vue';
import TutorialGuiado from '@/components/modal/TutorialGuiado.vue';
import RetiradaDetalhe from '@/components/modal/retirada_detalhe.vue';

export default {
  name: 'PedidoRetirada',
  components: {
    Header,
    Menu,
    arealogadapesquisa,
    footersite,
    footersitemobile,
    ModalPagamentoRealtime,
    TutorialGuiado,
    RetiradaDetalhe,
  },
  data() {
    return {
      logged: true,
      loading: false,
      tutorialAtivo: false,
      items: [],
      form: {},
      valorRetirada: 0,
      formasPagamentoRetirada: [
        { text: 'Selecione uma opção de pagamento', value: 0 },
        { text: 'PIX - Parcela Express ( Gratuito )', value: 3 },
      ],
      breadCrumb: [
        { text: 'Painel', href: '/painel' },
        { text: 'Envio de Títulos', disabled: true },
        { text: 'Retirada', active: true },
      ],
      colunas: [
        { key: 'cd_pedido_retirada',  label: 'Nº Retirada',   sortable: true,  size: '0.6fr' },
        { key: 'cd_pedido_protesto',  label: 'Nº Protesto',   sortable: true,  size: '0.6fr' },
        { key: 'nm_chave',            label: 'Chave',          sortable: false, size: '1.5fr' },
        { key: 'vl_retirada',         label: 'Valor Retirada', sortable: true,  size: '0.8fr', isCurrency: true },
        { key: 'dt_cotacao',          label: 'Dt. Cotação',    sortable: true,  size: '1fr',   isDate: true },
        { key: 'dt_cadastro',         label: 'Dt. Cadastro',   sortable: true,  size: '1fr',   isDate: true },
        { key: 'status_pedido',       label: 'Status',         sortable: false, size: '1fr',   isTagColor: true },
        {
          key: 'actions', label: 'Ação', sortable: false, size: '0.7fr',
          acoes: [
            { icone: 'eye',         tamanho: '1x', titulo: 'Ver Detalhes',        cor: 'text-info',    condicao: true,          funcao: 'verDetalhes'    },
            { icone: 'credit-card', tamanho: '1x', titulo: 'Realizar Pagamento', cor: 'text-success', condicao: 'ic_pagar',    funcao: 'abrirPagamento' },
            { icone: 'qrcode',      tamanho: '1x', titulo: 'Ver QR Code PIX',    cor: 'text-primary', condicao: 'ic_ver_pix', funcao: 'verPix'         },
          ]
        },
      ],
      colunasMobile: [
        { key: 'cd_pedido_retirada', label: 'Nº Retirada', sortable: false, size: '0.6fr' },
        { key: 'cd_pedido_protesto', label: 'Nº Protesto', sortable: false, size: '0.6fr' },
        { key: 'status_pedido',      label: 'Status',      sortable: false, size: '1fr',  isTagColor: true },
        {
          key: 'actions', label: 'Ação', sortable: false, size: '0.7fr',
          acoes: [
            { icone: 'eye',         tamanho: '1x', titulo: 'Ver Detalhes',        cor: 'text-info',    condicao: true,          funcao: 'verDetalhes'    },
            { icone: 'credit-card', tamanho: '1x', titulo: 'Realizar Pagamento', cor: 'text-success', condicao: 'ic_pagar',    funcao: 'abrirPagamento' },
            { icone: 'qrcode',      tamanho: '1x', titulo: 'Ver QR Code PIX',    cor: 'text-primary', condicao: 'ic_ver_pix', funcao: 'verPix'         },
          ]
        },
      ],
    };
  },
  computed: {
    itemFiltrado() {
      const relacao = this.items.map(item => ({
        cd_pedido_retirada:        item.cd_pedido_retirada,
        cd_pedido_protesto:        item.cd_pedido_protesto,
        nm_chave:                  item.nm_chave,
        vl_retirada:               item.vl_retirada,
        dt_cotacao:                item.dt_cotacao,
        dt_cadastro:               item.dt_cadastro,
        cd_pedido_retirada_status: item.cd_pedido_retirada_status,
        status_pedido:             { label: item.nm_status, color: this.corStatus(item.cd_pedido_retirada_status) },
        ic_pagar:                  item.cd_pedido_retirada_status == 2,
        ic_ver_pix:                item.cd_pedido_retirada_status == 3,
      }));

      if (this.tutorialAtivo) {
        relacao.unshift({
          cd_pedido_retirada:        'TUTORIAL',
          cd_pedido_protesto:        '000000',
          nm_chave:                  '00000000000000000000000000001',
          vl_retirada:               250.00,
          dt_cotacao:                new Date().toISOString(),
          dt_cadastro:               new Date().toISOString(),
          cd_pedido_retirada_status: 2,
          status_pedido:             { label: 'Aguardando Pagamento', color: '#ffc107' },
          ic_pagar:                  false,
          ic_ver_pix:                false,
          _is_tutorial_mock:         true,
        });
      }

      return relacao;
    },
  },
  created() {
    this.pesquisar();
  },
  watch: {
    tutorialAtivo(val) {
      if (val) {
        // Pré-carrega dados mock no modal de detalhe para quando o tutorial clicar no olho
        this.$nextTick(() => {
          if (this.$refs.modalRetiradaDetalhe) {
            this.$refs.modalRetiradaDetalhe.preCarregarMock();
          }
          this.$nextTick(() => {
            if (this.$refs.tutorial) this.$refs.tutorial.posicionarTooltip();
          });
        });
      }
    },
    itemFiltrado() {
      if (this.tutorialAtivo) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.tutorial) this.$refs.tutorial.posicionarTooltip();
          });
        });
      }
    },
  },
  mounted() {
    // Aguarda a renderização completa antes de iniciar o tutorial
    var self = this;
    this.$nextTick(function() {
      // PRODUÇÃO: usa o backend para decidir se exibe (ic_exibir_tutorial == true)
      self.$refs.tutorial.iniciar();

      // TESTE: descomente a linha abaixo para forçar exibição sem depender do backend
      // self.$refs.tutorial.forcarExibicao();
    });
  },
  methods: {
    montaFormBusca(filtros) {
      return {
        nrPedido:           filtros.nrPedido            || '',
        cd_pedido_protesto: filtros.cd_pedido_protesto  || '',
        dt_solicitacao_ini: filtros.dt_cadastro         || '',
        dt_solicitacao_fim: filtros.dtVencimento        || '',
      };
    },
    filtrarBusca(filtros) {
      this.form = this.montaFormBusca(filtros);
      this.pesquisar();
    },
    async pesquisar() {
      this.loading = true;
      try {
        const token = localStorage.getItem('jwtToken');
        const res = await API.post('pedido_retirada', { dados: this.form });
        this.items = (res.data && res.data.dados) ? res.data.dados : [];
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar',
          text: 'Não foi possível carregar os pedidos de retirada.',
          confirmButtonColor: '#d33',
        });
      } finally {
        this.loading = false;
      }
    },
    abrirPagamento(item) {
      this.valorRetirada = parseFloat(item.vl_retirada) || 0;
      this.$refs['modalPagamentoRetirada'].abrir({
        ...item,
        vl_custa: item.vl_retirada,
      });
    },
    verPix(item) {
      this.valorRetirada = parseFloat(item.vl_retirada) || 0;
      this.$refs['modalPagamentoRetirada'].abrirVisualizarPix({
        ...item,
        vl_custa: item.vl_retirada,
      });
    },
    onPagamentoRealizado() {
      this.pesquisar();
    },
    verDetalhes(item) {
      if (item._is_tutorial_mock) {
        this.$refs.modalRetiradaDetalhe.abrirMock();
        return;
      }
      this.$refs.modalRetiradaDetalhe.abrir(item.cd_pedido_retirada);
    },
    corStatus(status) {
      const map = {
        1: '#6c757d',  // Aguardando Cotação   — cinza
        2: '#ffc107',  // Aguardando Pagamento — amarelo
        3: '#17a2b8',  // Pago                 — azul
        4: '#dc3545',  // Cancelado            — vermelho
        5: '#28a745',  // Concluído            — verde
      };
      return map[status] || '#6c757d';
    },
    executarFuncao(funcao, linha) {
      if (this[funcao]) {
        this[funcao](linha);
      }
    },
  },
};
</script>

<style>
.breadcrumb {
  margin-left: 0px;
  background: unset;
}

.breadcrumb a,
.breadcrumb span,
.breadcrumb-item+.breadcrumb-item::before {
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: unset;
}

.breadcrumb a {
  color: var(--primary-color);
}

.breadcrumb-item+.breadcrumb-item::before {
  color: var(--primary-color);
}

.breadcrumb span {
  color: var(--secondary-color);
}

.breadcrumb a.disabled {
  text-decoration: none;
  cursor: default;
}

.btn-voltar {
  display: flex;
  align-items: center;
  margin-left: auto;
  letter-spacing: 0px;
  text-decoration: none;
  justify-content: flex-end !important;
  margin-bottom: 20px;
}

.btn-voltar img {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}
</style>